/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface NotificationServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     */
    notificationControllerSendRequestManagerAccess0(extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     */
    notificationControllerSendRequestManagerAccess1(extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     */
    notificationControllerSendTrialUpgradeRequest0(extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     */
    notificationControllerSendTrialUpgradeRequest1(extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param employerId 
     * @param inviterUsername 
     */
    notificationControllerSendUserInviteByEmployerId0(employerId: string, inviterUsername: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param employerId 
     * @param inviterUsername 
     */
    notificationControllerSendUserInviteByEmployerId1(employerId: string, inviterUsername: string, extraHttpRequestParams?: any): Observable<{}>;

}
